import React from "react";
import { Form, Row, Col, Button, Card } from "react-bootstrap";
import { useFormik } from "formik";
import { FetchPersonalizado, catchError } from "../../../utils/fetch";
import { useDispatch, useSelector } from "react-redux";
import { AlertInfo, AlertError } from "../../../components/alert";
import { loadingAction } from "../../../redux/actions";
import { validateModel } from "./validationSchema";  
import { useHistory } from "react-router-dom";
import "./style.css";

const NuevoNewsletter = () => {
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.loading);
    const history = useHistory();

    const submit = async (values) => {
      dispatch(loadingAction(true));

      try {
          // Crear un objeto FormData para enviar el archivo y los datos adicionales
          const formData = new FormData();
          
          formData.append("file", values.archivo); // El archivo .zip
          formData.append("nombreGenerico", values.titulo); // El título del newsletter
          
          // Convertir mes y año en un DateTime válido para enviarlo al backend
          const { mes, anio } = values;
          const mesIndex = meses.indexOf(mes) + 1; // Meses en inglés van de 1 a 12
          const fechaPublicacion = new Date(`${anio}-${mesIndex.toString().padStart(2, '0')}-01`).toISOString(); // Primer día del mes
          formData.append("fechaPublicacion", fechaPublicacion);


          // Realizar la llamada al backend usando Fetch
          await FetchPersonalizado("FileUpload/upload", "post", formData);

          AlertInfo("Newsletter creado con éxito. Notifique al responsable para publicar.");
          history.push("/newsletter/lista");

          dispatch(loadingAction(false));
      } catch (error) {
          catchError(error);
          AlertError("Error al crear el newsletter. Intente de nuevo.");
          dispatch(loadingAction(false));
      }
  };

    const {
        values,
        handleSubmit,
        handleChange,
        handleBlur,
        setFieldValue,
        errors,
        touched,
    } = useFormik({
        initialValues: {
            titulo: "",   // Título del newsletter
            anio: "",     // Año de publicación
            mes: "",      // Mes de publicación
            archivo: null,  // Archivo a subir (null inicialmente)
        },
        validationSchema: validateModel,  
        onSubmit: (values) => {
            const payload = {
                titulo: values.titulo,
                anio: values.anio,
                mes: values.mes,
                archivo: values.archivo, // El archivo
            };
            submit(payload); 
        },
    });

    // Función para cambiar los valores de fecha
    const cambiarFecha = (item, value) => {
        setFieldValue(item, value);
    };

    const meses = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];

    const anios = Array.from(new Array(30), (val, index) => new Date().getFullYear() - index);

    return (
        <React.Fragment>
            <form onSubmit={handleSubmit}>
                <Row>
                    <Col>
                        <Card>
                            <Card.Header>
                                <Row>
                                    <Col>Nuevo Newsletter</Col>
                                </Row>
                            </Card.Header>
                            <Card.Body>
                                {/* Input del título */}
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <label>Título Newsletter</label>
                                            <input
                                                type="text"
                                                name="titulo"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.titulo}
                                                className="form-control"
                                            />
                                            {touched?.titulo && (
                                                <div className="text-danger">{errors?.titulo}</div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {/* Sección de selección de mes y año */}
                                <Row>
                                    <Col md={3} className="d-flex align-items-center">
                                        <Form.Group>
                                            <label>Fecha publicación Newsletter</label>
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Group>
                                            <select
                                                className="form-control"
                                                name="mes"
                                                onChange={(e) => cambiarFecha("mes", e.target.value)}
                                                onBlur={handleBlur}
                                                value={values.mes || ""}
                                            >
                                                <option value="">Mes</option>
                                                {meses.map((mes, index) => (
                                                    <option key={index} value={mes}>
                                                        {mes}
                                                    </option>
                                                ))}
                                            </select>
                                            {touched?.mes && (
                                                <div className="text-danger">{errors?.mes}</div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Group>
                                            <select
                                                className="form-control"
                                                name="anio"
                                                onChange={(e) => cambiarFecha("anio", e.target.value)}
                                                onBlur={handleBlur}
                                                value={values.anio || ""}
                                            >
                                                <option value="">Año</option>
                                                {anios.map((anio, index) => (
                                                    <option key={index} value={anio}>
                                                        {anio}
                                                    </option>
                                                ))}
                                            </select>
                                            {touched?.anio && (
                                                <div className="text-danger">{errors?.anio}</div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {/* Input para el archivo tipo .zip */}
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <label>Archivo (.zip)</label>
                                            <input
                                                type="file"
                                                name="archivo"
                                                accept=".zip"
                                                className="form-control"
                                                onChange={(event) => {
                                                    setFieldValue("archivo", event.target.files[0]);
                                                }}
                                            />
                                            {touched?.archivo && (
                                                <div className="text-danger">{errors?.archivo}</div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Button
                                    type="submit"
                                    disabled={isLoading}
                                    className="btn btn-success btn-icon mt-2"
                                >
                                    <i className="fa fa-floppy-o" />
                                    Guardar
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </form>
        </React.Fragment>
    );
};

export default NuevoNewsletter;
